// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"244":"ef861bc6","352":"f259e67b","781":"6547aaf2","966":"e56c73e0"}[chunkId] + ".js";
};